import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const TitleLink = props => (props.to ? <Link {...props} /> : props.children);

const Overflow = props => (
  <div className="page-header__overflow">
    {props.text && (
      <div className="page-header__overflow-line">{props.text}</div>
    )}
    {props.lines &&
      props.lines.map((line, index) => (
        <div key={index} className="page-header__overflow-line-sub">
          {line}
        </div>
      ))}
  </div>
);

/**
 * A page title with optional subtitle
 */
const Title = ({
  team,
  logo,
  linkTo,
  title,
  subtitle,
  highlight,
  overflow,
}) => {
  if (team) {
    logo = team.image;
    title = team.name;
  }
  highlight = highlight !== undefined ? highlight : !!subtitle;

  return (
    <header className="page-header">
      <div
        className={`page-header__logo ${logo && 'is-fade-loaded'}`}
        style={logo && { backgroundImage: `url(${logo})` }}
      />
      <div className="page-header__title">
        <TitleLink to={linkTo}>
          <h1 className={title ? 'is-fade-loaded' : 'is-fade-loading'}>
            {title || '...'}
          </h1>
        </TitleLink>

        {subtitle && (
          <p
            className={
              'page-header__subtitle' +
              (highlight ? ' page-header__subtitle--highlight' : '')
            }
          >
            {subtitle}
          </p>
        )}
      </div>
      <div className="page-header__right">
        {overflow && <Overflow {...overflow} />}
      </div>
    </header>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  linkTo: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  highlight: PropTypes.bool,
};

export default Title;
